module.exports = __webpack_public_path__ + "static/media/plaid-logo.6f98f876.svg";